import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  DialogActions,
} from '@mui/material';

interface ProjectProfileModalProps {
  dialogContent: React.ReactNode;
  dialogActions: React.ReactNode;
  open: boolean;
  onClose: () => void;
  headerTitle: string;
  onSave: (data: {
    description: string;
    entityName: string;
    projectId: string;
    attorneys: string;
  }) => void;
}

const ProjectProfileDialog: React.FC<ProjectProfileModalProps> = ({
  open,
  onClose,
  headerTitle,
  dialogContent,
  dialogActions,
}) => {
  return (
    <Dialog
      open={open}
      PaperProps={{className: 'evidence-source-dialog'}}
      onClose={onClose}
      maxWidth={false}
      fullWidth
    >
      <DialogTitle className="profile-color" tabIndex={0}>
        <Typography className="typo-text headline2_size">{headerTitle}</Typography>
      </DialogTitle>

      <DialogContent className="custom-dialog-content" tabIndex={0}>
        {dialogContent}
      </DialogContent>

      {/* Footer Buttons */}
      <DialogActions className="profile-dialog-footer" tabIndex={0}>
        {dialogActions}
      </DialogActions>
    </Dialog>
  );
};

export default ProjectProfileDialog;
